import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { Input } from 'antd';
import axios from "axios";
import configData from "../../config/config.json";
import { notifysuccess } from "../../utils/toast";
import { notifyfailure } from "../../utils/toast";
import { notifycatch } from "../../utils/toast";
import { TokenVerificationLoggedOut } from "../../utils/tokenVerify";
import { jwtDecode } from "jwt-decode";
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
import 'swiper/css';
import { Link } from "react-router-dom";

import Logo from '../../assets/newlayout/logo.svg'

import NewLeftImgOne from '../../assets/newlayout/new_one/first_box/one.svg'
import NewLeftImgTwo from '../../assets/newlayout/new_one/first_box/two.svg'
import NewLeftImgThree from '../../assets/newlayout/new_one/first_box/three.svg'
import NewLeftImgFour from '../../assets/newlayout/new_one/first_box/four.svg'

import NewRightImgOne from '../../assets/newlayout/new_one/second_box/first.svg'
import NewRightImgTwo from '../../assets/newlayout/new_one/second_box/second.svg'
import NewRightImgThree from '../../assets/newlayout/new_one/second_box/third.svg'

import NewBottomLeftImgOne from '../../assets/newlayout/new_one/third_box/one.svg'
import NewBottomLeftImgTwo from '../../assets/newlayout/new_one/third_box/two.svg'
import NewBottomLeftImgThree from '../../assets/newlayout/new_one/third_box/three.svg'

import NewBottomRightImgOne from '../../assets/newlayout/new_one/four_box/one.svg'
import NewBottomRightImgTwo from '../../assets/newlayout/new_one/four_box/two.svg'
import NewBottomRightImgThree from '../../assets/newlayout/new_one/four_box/three.svg'


const LoginV2 = () => {

    const [loading, setLoading] = useState(true);
    const [formState, setFormState] = useState(2); // 2 = login, 3 = OTP
    const buttonRef1 = useRef(null);
    const buttonRef2 = useRef(null);
    const otpRef = useRef(null);

    const [ip, setIp] = useState(null);

    React.useEffect(() => {
        getIP()
    }, [])

    const getIP = async () => {
        try {
            const res = await axios.get("https://geolocation-db.com/json/");
            Cookies.set("IP", res.data.IPv4, { expires: 1 });
            setIp(res.data.IPv4)
        } catch (error) { }

    };


    useEffect(() => {
        TokenVerificationLoggedOut();
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (!status) {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const handleEnterKeyPress1 = (event) => {
            if (event.key === "Enter" && buttonRef1 && buttonRef1?.current) {
                buttonRef1?.current.click();
            }
        };

        document.addEventListener("keydown", handleEnterKeyPress1);

        return () => {
            document.removeEventListener("keydown", handleEnterKeyPress1);
        };
    }, []);

    useEffect(() => {
        const handleEnterKeyPress2 = (event) => {
            if (event.key === "Enter" && buttonRef2 && buttonRef2?.current) {
                buttonRef2?.current.click();
            }
        };
        document.addEventListener("keydown", handleEnterKeyPress2);
        return () => {
            document.removeEventListener("keydown", handleEnterKeyPress2);
        };
    }, []);


    useEffect(() => {
        if (formState === 3 && otpRef.current) {
            setTimeout(() => {
                otpRef.current.focus();
            }, 500)

        }
    }, [formState]);


    // /////////////////////////////////////Logincode ////////////////////////////////////////////////

    const [email, setEmail] = useState("");
    const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);
    const [emailUrlError, setEmailUrlError] = useState(false);

    const [buttonValueEmail, setButtonValueEmail] = useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    function onChangeEmail(event) {
        setEmail(event.target.value.trim());

        if (event.target.value.trim().length === 0) {
            setEmailUrlError(false);
            setEmailIsRequiredError(true);
        } else {
            setEmailIsRequiredError(false);
            if (validateEmail(event.target.value.trim()) === null) {
                setEmailUrlError(true);
            } else {
                setEmailUrlError(false);
            }
        }
    }

    function onBlurEmail(event) {
        setEmail(email.trim());
        if (event.target.value.trim().length === 0) {
            setEmailUrlError(false);
            setEmailIsRequiredError(true);
        }
    }


    function resetLoginScreen() {
        setEmail("")
        setEmailIsRequiredError(false)
        setEmailUrlError(false)
        setButtonValueEmail(false)
        setOtp("")
        setOtpIsRequiredError(false)
        setOtpLengthError(false)
        setButtonValueOtp(false)
        setButtonValueResend(false)
        setCountdown(60)
    }

    const handleSubmitEmail = async (e) => {
        e.preventDefault();

        if (email !== "") {
            if (emailIsRequiredError === false && emailUrlError === false) {
                let payload = {
                    email: email,
                };

                setButtonValueEmail(true);

                axios
                    .post(configData.SERVER_URL + "user/sendOtp", payload)
                    .then((response) => {
                        notifysuccess(response.data.message);
                        setButtonValueEmail(false);
                        setButtonValueResend(true)
                        handleTimeout()
                        setFormState(3);
                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                notifyfailure(error.response.data.message);
                            }
                        } else {
                            notifycatch();
                        }
                        setButtonValueEmail(false);
                    });
            }
        } else {
            if (email === "") {
                setEmailIsRequiredError(true);
            }
        }
    };


    // /////////////////////////////////////Otp code ////////////////////////////////////////////////

    const [otp, setOtp] = useState("");
    const [otpIsRequiredError, setOtpIsRequiredError] = useState(false);
    const [otpLengthError, setOtpLengthError] = useState(false);
    const [buttonValueOtp, setButtonValueOtp] = useState(false);
    const [buttonValueResend, setButtonValueResend] = useState(false);

    const [countdown, setCountdown] = useState(60);

    const resendOtp = () => {
        setCountdown(60)
        setButtonValueResend(true)

        let payload = {
            email: email,
        };
        axios
            .post(configData.SERVER_URL + "user/sendOtp", payload)
            .then((response) => {
                notifysuccess(response.data.message);
                handleTimeout()

            })
            .catch((error) => {
                if (error.response.data.message?.length !== 0) {
                    notifyfailure(error.response.data.message);

                } else {
                    notifycatch();
                }

                setButtonValueResend(false)
            });

    }


    const handleTimeout = () => {
        setCountdown(60);
        const timerInterval = setInterval(() => {
            setCountdown(prevCountdown => {
                if (prevCountdown <= 1) {
                    clearInterval(timerInterval);
                    setButtonValueResend(false);
                    return 0;
                }
                return prevCountdown - 1;
            });
        }, 1000);
    };

    function onChangeOtp(value) {
        const trimmedValue = value.trim();

        if (trimmedValue.length === 0) {
            setOtpLengthError(false);
            setOtpIsRequiredError(true);
            setOtp(trimmedValue);
        } else {
            setOtpLengthError(false);
            if (/^\d*$/.test(trimmedValue)) {
                setOtpIsRequiredError(false);
                if (trimmedValue.length <= 6) {
                    setOtp(trimmedValue);
                    setTimeout(() => {
                        if (trimmedValue.length === 6) {
                            buttonRef2?.current.click();
                        }
                    }, 0);
                } else {
                    setOtp(trimmedValue.slice(0, 6));
                }
            }
        }
    }

    function onBlurOtp() {
        const trimmedOtp = otp.trim();
        setOtp(trimmedOtp);

        if (trimmedOtp.length === 0) {
            setOtpLengthError(false);
            setOtpIsRequiredError(true);
        } else if (trimmedOtp.length < 6) {
            setOtpIsRequiredError(false);
            setOtpLengthError(true);
        }
    }

    const handleSubmitOtp = async (e) => {
        e.preventDefault();

        if (otp !== "" && otp.trim().length === 6) {
            if (otpIsRequiredError === false && otpLengthError === false) {
                let payload = {
                    email: email,
                    otp: otp,
                    ip: ip
                };

                setButtonValueOtp(true);

                axios
                    .post(configData.SERVER_URL + "user/verifyOtp", payload)
                    .then((response) => {
                        notifysuccess(response.data.message);
                        setTimeout(() => {
                            let id = jwtDecode(response.data.data.token)._id;
                            let role = jwtDecode(response.data.data.token).role;
                            let token = response.data.data.token;

                            if ((role === "admin" || role === "u_admin")) {
                                axios
                                    .get(configData.SERVER_URL + "user/status?_id=" + id)
                                    .then((response) => {
                                        if (response.data.data.status === "new" || response.data.data.status === "onboard" || response.data.data.status === "rejected") {
                                            Cookies.set("token_xapads_ssp", token, { expires: 1 });
                                            window.location.replace("/onboarding");
                                        } else {
                                            Cookies.set("token_xapads_ssp", token, { expires: 1 });
                                            window.location.replace("/dashboard");
                                        }
                                    })
                                    .catch((error) => {
                                        Cookies.set("token_xapads_ssp", token, { expires: 1 });
                                        window.location.replace("/dashboard");
                                    });
                            } else {
                                Cookies.set("token_xapads_ssp", token, { expires: 1 });
                                window.location.replace("/dashboard");
                            }
                        }, 0);
                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                notifyfailure(error.response.data.message);
                            }
                        } else {
                            notifycatch();
                        }
                        setButtonValueOtp(false);
                    });
            }
        } else {
            if (otp === "") {
                setOtpIsRequiredError(true);
            } else {
                if (otp.trim().length !== 6) {
                    setOtpLengthError(true);
                }
            }
        }
    };


    if (loading) {
        return (
            <>
                <div className="fullscreen"></div>
            </>
        );
    } else {
        return (
            <div>

                <div className="new_sign_up_in_div">
                    <div className="left">
                        <div className="new_left">
                            <ul>
                                <li>
                                    <img src={NewLeftImgOne} className="img-fluid" alt="" />
                                    <img src={NewLeftImgTwo} className="img-fluid" alt="" />
                                    <img src={NewLeftImgThree} className="img-fluid" alt="" />
                                    <img src={NewLeftImgFour} className="img-fluid" alt="" />
                                </li>
                                <li>
                                    <img src={NewRightImgOne} className="img-fluid" alt="" />
                                    <img src={NewRightImgTwo} className="img-fluid" alt="" />
                                    <img src={NewRightImgThree} className="img-fluid" alt="" />
                                </li>
                                <li>
                                    <img src={NewBottomLeftImgOne} className="img-fluid" alt="" />
                                    <img src={NewBottomLeftImgTwo} className="img-fluid" alt="" />
                                    <img src={NewBottomLeftImgThree} className="img-fluid" alt="" />
                                </li>
                                <li>
                                    <img src={NewBottomRightImgOne} className="img-fluid" alt="" />
                                    <img src={NewBottomRightImgTwo} className="img-fluid" alt="" />
                                    <img src={NewBottomRightImgThree} className="img-fluid" alt="" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    {formState === 2 ?
                        //signin
                        <div className="right">
                            <img src={Logo} className='img-fluid' alt="" />
                            <div className="login-box">
                                <h2>Welcome back!</h2>
                                <label htmlFor="">Email Address <span>*</span></label>
                                <Input prefix={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M7.99967 10.6663C9.47243 10.6663 10.6663 9.47243 10.6663 7.99967C10.6663 6.52692 9.47243 5.33301 7.99967 5.33301C6.52692 5.33301 5.33301 6.52692 5.33301 7.99967C5.33301 9.47243 6.52692 10.6663 7.99967 10.6663Z" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10.6663 5.33357V8.6669C10.6663 9.19734 10.8771 9.70605 11.2521 10.0811C11.6272 10.4562 12.1359 10.6669 12.6663 10.6669C13.1968 10.6669 13.7055 10.4562 14.0806 10.0811C14.4556 9.70605 14.6663 9.19734 14.6663 8.6669V8.00024C14.6663 6.49559 14.1572 5.03522 13.2219 3.85659C12.2866 2.67796 10.98 1.85039 9.51477 1.50844C8.0495 1.16648 6.51164 1.33027 5.15125 1.97315C3.79086 2.61603 2.68795 3.70021 2.02185 5.04939C1.35576 6.39856 1.16566 7.9334 1.48246 9.40431C1.79926 10.8752 2.60433 12.1957 3.76677 13.1511C4.9292 14.1064 6.38064 14.6405 7.88506 14.6663C9.38948 14.6922 10.8584 14.2084 12.053 13.2936" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                }

                                    className={
                                        emailIsRequiredError || emailUrlError
                                            ? " error"
                                            : ""
                                    }
                                    placeholder="example@gmail.com"
                                    value={email}
                                    onBlur={onBlurEmail}
                                    onChange={onChangeEmail}
                                    autocomplete="off"

                                />
                                <span className="error_content h_error">
                                    {emailIsRequiredError && (
                                        <> This field is required</>
                                    )}
                                    {emailUrlError && (
                                        <> Invalid Email Address</>
                                    )}

                                </span>
                                {!buttonValueEmail && (
                                    <button
                                        onClick={handleSubmitEmail}
                                        ref={buttonRef1}
                                    >Submit</button>
                                )}

                                {buttonValueEmail && (
                                    <button
                                        className="btn_primary btn loader"

                                    >
                                        <span>SUBMIT</span>
                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>

                                )}

                                <p>Don't have an account?
                                    {buttonValueEmail ?
                                        <span className="primary ms-1"
                                        >
                                            Sign Up
                                        </span>
                                        :
                                        <Link to="/signup" className="primary ms-1"
                                            style={{ textDecoration: "underline", cursor: "pointer" }}
                                        >
                                            Sign Up
                                        </Link>
                                    }
                                </p>
                            </div>
                        </div>
                        :
                        //otp

                        <div className="right">
                            <img src={Logo} className='img-fluid' alt="" />
                            <div className="login-box">
                                <h2 className='mb-0'>OTP Verification</h2>
                                <p className='sing_up_para'>We sent a code to <span>{email} </span></p>
                                <div className='sign_up_form_input_div'>
                                    <div>
                                        <div className='otp_resend_btn'>
                                            <label htmlFor="">Enter OTP</label>
                                            {buttonValueResend ?
                                                <span to="/" className="error_label">
                                                    <span className="dark">Resend OTP in</span> <span className="w_countdown">00:{countdown}</span>
                                                </span>
                                                :
                                                <span className="resend_btn"
                                                    onClick={resendOtp}
                                                >
                                                    RESEND
                                                </span>
                                            }

                                        </div>
                                        <div className='otp_input_div'>
                                            <Input.OTP
                                                ref={otpRef}
                                                length={6}
                                                value={otp}
                                                onChange={onChangeOtp}
                                                onBlur={onBlurOtp}
                                                status={otpIsRequiredError || otpLengthError ? "error" : ""}
                                                formatter={(str) => str.toUpperCase()}
                                            />

                                            <span className="error_content h_error">
                                                {otpIsRequiredError && <> This field is required</>}
                                                {otpLengthError && <> OTP should be 6 characters</>}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {!buttonValueOtp && (

                                    <button
                                        className="btn_primary btn"
                                        ref={buttonRef2}
                                        onClick={handleSubmitOtp}
                                    >
                                        <span>Submit</span>
                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>

                                )}

                                {buttonValueOtp && (

                                    <button className="btn_primary btn loader">
                                        <span>SUBMIT</span>
                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>

                                )}
                            </div>
                        </div>

                    }
                </div>

            </div>
        )
    }
}

export default LoginV2
